import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { ReferenceType } from "../../../apis/networkdashboard/graphql/graphql";

@Component({
  selector: "[third-party-service-ids-row-content]",
  templateUrl: "third-party-service-ids-row-content.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class ThirdPartyServiceIdsRowContentComponent {
  references = input.required<ReferenceType[]>();
}
